// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%235f6368%27 d=%27M6 8L1 3h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Variables ── */
:root {
  --bg: #f0f2f5;
  --surface: #ffffff;
  --surface-2: #f8f9fb;
  --border: #e0e3e8;
  --border-hover: #c4c8d2;
  --accent: #1a73e8;
  --accent-dark: #1558b0;
  --accent-soft: #e8f0fe;
  --accent-glow: rgba(26,115,232,0.18);
  --nav-blue: #1a73e8;
  --nav-blue-dark: #1252a3;
  --nav-blue-active: #0f3d7a;
  --text-primary: #1c1e21;
  --text-secondary: #5f6368;
  --text-muted: #9aa0a6;
  --shadow-sm: 0 1px 4px rgba(0,0,0,0.07);
  --shadow-md: 0 4px 16px rgba(0,0,0,0.1);
  --shadow-lg: 0 8px 32px rgba(0,0,0,0.12);
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --status-processing-bg: #fff8e1;
  --status-processing-color: #f59e0b;
  --status-shipped-bg: #e0f2fe;
  --status-shipped-color: #0284c7;
  --status-delivered-bg: #dcfce7;
  --status-delivered-color: #16a34a;
  --status-cancelled-bg: #fee2e2;
  --status-cancelled-color: #dc2626;
}

* { box-sizing: border-box; }

/* ══════════════════════════════════════
   MAIN LAYOUT
══════════════════════════════════════ */
.my-orders-container {
  display: flex;
  min-height: calc(100vh - 60px);
  margin-top: 70px;
  padding-top: 30px;
  background-color: var(--bg);
  font-family: 'DM Sans', sans-serif;
}

@media (min-width: 1024px) {
  .my-orders-container {
    margin-top: 70px;
    padding-top: 34px;
  }
}

/* ══════════════════════════════════════
   SIDEBAR NAV
══════════════════════════════════════ */
.main-nav {
  width: 280px;
  background: linear-gradient(160deg, #1a73e8 0%, #1252a3 100%);
  color: white;
  padding: 28px 0;
  height: calc(100vh - 70px);
  position: fixed;
  top: 70px;
  left: 0;
  box-shadow: 4px 0 20px rgba(26,115,232,0.25);
  display: flex;
  flex-direction: column;
  z-index: 100;
}

.main-nav .nav-header {
  padding: 0 24px 24px;
  margin-bottom: 8px;
  font-size: 1.3rem;
  font-weight: 700;
  color: white;
  letter-spacing: -0.3px;
  border-bottom: 1px solid rgba(255,255,255,0.15);
}

.main-nav .nav-header::before {
  content: '📦 ';
  font-size: 1.1rem;
}

.main-nav ul {
  list-style: none;
  padding: 12px 0;
  margin: 0;
  flex: 1 1;
}

.main-nav li {
  margin: 4px 12px;
  padding: 13px 16px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: var(--radius-sm);
  transition: all 0.2s ease;
  color: rgba(255,255,255,0.85);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.main-nav li:hover {
  background: rgba(255,255,255,0.12);
  color: white;
  padding-left: 20px;
}

.main-nav li.active {
  background: rgba(255,255,255,0.2);
  color: white;
  font-weight: 700;
  border-left: 3px solid white;
  padding-left: 13px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.15);
}

.orders-count-badge {
  background: rgba(255,255,255,0.25);
  color: white;
  border-radius: 100px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 700;
  min-width: 24px;
  text-align: center;
  border: 1px solid rgba(255,255,255,0.3);
}

/* ══════════════════════════════════════
   CONTENT AREA
══════════════════════════════════════ */
.orders-content {
  flex: 1 1;
  margin-left: 280px;
  padding: 32px 36px;
  background-color: var(--bg);
  min-height: calc(100vh - 70px);
}

/* ── Orders Header ── */
.orders-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 18px;
  border-bottom: 2px solid var(--border);
}

.orders-header h1 {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  letter-spacing: -0.4px;
}

/* ── Filter ── */
.orders-filter {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 24px;
}

.orders-filter span {
  font-weight: 600;
  color: var(--text-secondary);
  font-size: 14px;
}

.orders-filter select,
.status-dropdown {
  padding: 9px 14px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background-color: var(--surface);
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  color: var(--text-primary);
  cursor: pointer;
  box-shadow: var(--shadow-sm);
  transition: border-color 0.2s, box-shadow 0.2s;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  padding-right: 30px;
}

.orders-filter select:focus,
.status-dropdown:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
}

/* ══════════════════════════════════════
   ORDER CARD
══════════════════════════════════════ */
.order-card {
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  margin-bottom: 20px;
  background: var(--surface);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  animation: fadeUp 0.3s ease both;
}

.order-card:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

@keyframes fadeUp {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* Stagger cards */
.order-card:nth-child(1) { animation-delay: 0.04s; }
.order-card:nth-child(2) { animation-delay: 0.08s; }
.order-card:nth-child(3) { animation-delay: 0.12s; }
.order-card:nth-child(4) { animation-delay: 0.16s; }
.order-card:nth-child(5) { animation-delay: 0.20s; }

/* ── Order Card Header Bar ── */
.order-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px 20px;
  background: var(--surface-2);
  border-bottom: 1px solid var(--border);
  flex-wrap: wrap;
  gap: 12px;
}

.order-meta {
  display: flex;
  gap: 28px;
  flex-wrap: wrap;
}

.order-date,
.order-total {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.order-date span:first-child,
.order-total span:first-child {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: var(--text-muted);
}

.order-date span:last-child,
.order-total span:last-child {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.order-id {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
}

.order-id span {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-muted);
}

.order-id a {
  color: var(--accent);
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  transition: color 0.15s;
}

.order-id a:hover {
  color: var(--accent-dark);
  text-decoration: underline;
}

/* ── Status Bar ── */
.order-status-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  border-bottom: 1px solid var(--border);
  gap: 12px;
  flex-wrap: wrap;
}

.order-status {
  font-weight: 600;
  font-size: 13px;
  padding: 6px 14px;
  border-radius: 100px;
  letter-spacing: 0.2px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.order-status::before {
  content: '';
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.7;
}

.status-processing {
  background: var(--status-processing-bg);
  color: var(--status-processing-color);
}

.status-out,
.status-shipped {
  background: var(--status-shipped-bg);
  color: var(--status-shipped-color);
}

.status-delivered {
  background: var(--status-delivered-bg);
  color: var(--status-delivered-color);
}

.status-cancelled {
  background: var(--status-cancelled-bg);
  color: var(--status-cancelled-color);
}

/* ── Cancel Button ── */
.cancel-order-btn {
  background: transparent;
  border: 1px solid var(--status-cancelled-color);
  color: var(--status-cancelled-color);
  padding: 6px 14px;
  border-radius: 100px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.18s ease;
}

.cancel-order-btn:hover {
  background: var(--status-cancelled-color);
  color: white;
}

/* ── Order Items ── */
.order-items {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0 20px;
}

.order-item {
  display: flex;
  gap: 16px;
  padding: 18px 0;
  border-bottom: 1px solid var(--border);
  transition: background 0.15s;
  position: relative;
}

.order-item:last-child {
  border-bottom: none;
}

.order-item:hover {
  background: var(--surface-2);
  margin: 0 -20px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 0;
}

.order-item-image {
  width: 78px;
  height: 78px;
  object-fit: contain;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: white;
  padding: 6px;
  flex-shrink: 0;
}

.order-item-details {
  flex: 1 1;
  min-width: 0;
}

.order-item-name {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 5px;
  line-height: 1.4;
}

.order-item-price {
  font-weight: 700;
  color: var(--text-primary);
  font-size: 15px;
  margin-bottom: 4px;
}

.order-item-quantity,
.order-item-page {
  color: var(--text-secondary);
  font-size: 13px;
  margin-bottom: 2px;
}

/* ── Item Actions ── */
.order-item-actions {
  display: flex;
  gap: 16px;
  margin-top: 10px;
}

.action-btn {
  background: none;
  border: none;
  color: var(--accent);
  cursor: pointer;
  font-size: 13px;
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  padding: 0;
  transition: color 0.15s;
}

.action-btn:hover {
  color: var(--accent-dark);
  text-decoration: underline;
}

/* ── Order Footer ── */
.order-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid var(--border);
  background: var(--surface-2);
}

.track-package-btn,
.leave-feedback-btn {
  background: var(--surface);
  border: 1px solid var(--border);
  padding: 8px 16px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-family: 'DM Sans', sans-serif;
  font-weight: 500;
  color: var(--text-primary);
  transition: all 0.18s ease;
  box-shadow: var(--shadow-sm);
}

.track-package-btn:hover,
.leave-feedback-btn:hover {
  background: var(--accent-soft);
  border-color: var(--accent);
  color: var(--accent);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px var(--accent-glow);
}

/* ══════════════════════════════════════
   CUSTOMER INFO (Merchant View)
══════════════════════════════════════ */
.customer-info {
  margin: 16px 20px;
  padding: 16px;
  background: var(--accent-soft);
  border: 1px solid rgba(26,115,232,0.2);
  border-radius: var(--radius-md);
  border-left: 4px solid var(--accent);
}

.customer-info span,
.customer-detail {
  font-size: 13.5px;
  color: var(--text-secondary);
  display: flex;
  gap: 6px;
  margin-bottom: 4px;
}

.customer-detail strong {
  color: var(--text-primary);
  font-weight: 600;
}

/* ── Customer Orders List (legacy) ── */
.customer-orders-list {
  margin-top: 100px;
  font-family: 'DM Sans', sans-serif;
}

.customer-orders-list h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 20px;
  padding-bottom: 14px;
  border-bottom: 2px solid var(--border);
}

/* ══════════════════════════════════════
   LOADING SPINNER
══════════════════════════════════════ */
.flipkart-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 220px;
  width: 100%;
}

.spinner-container {
  text-align: center;
}

.spinner {
  border: 3px solid var(--accent-soft);
  border-radius: 50%;
  border-top-color: var(--accent);
  width: 40px;
  height: 40px;
  animation: spin 0.75s linear infinite;
  margin: 0 auto 14px;
  box-shadow: 0 0 12px var(--accent-glow);
}

.loading-text {
  color: var(--accent);
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.2px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ══════════════════════════════════════
   EMPTY STATE
══════════════════════════════════════ */
.empty-orders {
  text-align: center;
  padding: 60px 40px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  margin-top: 10px;
}

.empty-orders-icon {
  font-size: 52px;
  margin-bottom: 18px;
  color: var(--text-muted);
  opacity: 0.6;
}

.empty-orders h3 {
  font-size: 20px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.empty-orders p {
  color: var(--text-secondary);
  margin-bottom: 24px;
  font-size: 14px;
  max-width: 320px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
}

.continue-shopping-btn {
  background: var(--accent);
  color: white;
  border: none;
  padding: 11px 28px;
  border-radius: 100px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
  box-shadow: 0 3px 12px var(--accent-glow);
}

.continue-shopping-btn:hover {
  background: var(--accent-dark);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px var(--accent-glow);
}

/* ══════════════════════════════════════
   POPUP MODAL
══════════════════════════════════════ */
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  backdrop-filter: blur(4px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.15s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

.popup-modal {
  background: var(--surface);
  padding: 36px 32px 28px;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  max-width: 420px;
  width: 90%;
  text-align: center;
  animation: slideUp 0.2s ease;
  border: 1px solid var(--border);
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
}

.popup-modal p {
  margin-bottom: 24px;
  font-size: 16px;
  color: var(--text-primary);
  font-weight: 500;
  line-height: 1.5;
}

.popup-modal .modal-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.confirm-remove-btn {
  background: #dc2626;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.18s ease;
  flex: 1 1;
  max-width: 160px;
}

.confirm-remove-btn:hover {
  background: #b91c1c;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220,38,38,0.3);
}

.cancel-remove-btn {
  background: var(--surface-2);
  color: var(--text-secondary);
  border: 1px solid var(--border);
  padding: 10px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.18s ease;
  flex: 1 1;
  max-width: 160px;
}

.cancel-remove-btn:hover {
  background: var(--border);
  color: var(--text-primary);
}

/* ══════════════════════════════════════
   LEGACY / STANDALONE ORDERS CONTAINER
══════════════════════════════════════ */
.orders-container {
  max-width: 1100px;
  margin: 120px auto 40px;
  padding: 0 20px;
  font-family: 'DM Sans', sans-serif;
}

/* ══════════════════════════════════════
   RESPONSIVE
══════════════════════════════════════ */
@media (max-width: 900px) {
  .my-orders-container {
    flex-direction: column;
    margin-top: 70px;
    padding-top: 0;
  }

  .main-nav {
    width: 100%;
    height: auto;
    position: static;
    padding: 12px 0;
    box-shadow: 0 4px 12px rgba(26,115,232,0.2);
  }

  .main-nav .nav-header {
    padding: 0 16px 12px;
    margin-bottom: 4px;
    font-size: 1.1rem;
  }

  .main-nav ul {
    display: flex;
    overflow-x: auto;
    padding: 4px 8px;
    gap: 4px;
    scrollbar-width: none;
  }

  .main-nav ul::-webkit-scrollbar { display: none; }

  .main-nav li {
    margin: 0;
    padding: 10px 16px;
    white-space: nowrap;
    border-radius: 100px;
    border-left: none !important;
    flex-shrink: 0;
  }

  .main-nav li.active {
    background: rgba(255,255,255,0.25);
    border-bottom: none;
    padding-left: 16px;
  }

  .orders-content {
    margin-left: 0;
    padding: 20px 16px;
  }

  .orders-container {
    margin-top: 60px;
  }
}

@media (max-width: 600px) {
  .orders-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .orders-header h1 { font-size: 1.4rem; }

  .order-header {
    flex-direction: column;
    gap: 10px;
  }

  .order-meta { gap: 14px; }

  .order-id { align-items: flex-start; }

  .order-item {
    flex-direction: column;
  }

  .order-item-image {
    width: 100%;
    height: 140px;
    border-radius: var(--radius-md);
  }

  .order-footer {
    flex-direction: column;
  }

  .track-package-btn,
  .leave-feedback-btn {
    justify-content: center;
  }

  .status-dropdown { width: 100%; }

  .orders-content { padding: 14px 12px; }
}

@media (max-width: 400px) {
  .orders-content { padding: 10px 8px; }
  .order-card { border-radius: var(--radius-sm); }
  .main-nav .nav-header { font-size: 1rem; }
  .popup-modal { padding: 24px 18px 20px; }
}`, "",{"version":3,"sources":["webpack://./src/components/Orders.css"],"names":[],"mappings":"AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,oCAAoC;EACpC,mBAAmB;EACnB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,uCAAuC;EACvC,uCAAuC;EACvC,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,+BAA+B;EAC/B,kCAAkC;EAClC,4BAA4B;EAC5B,+BAA+B;EAC/B,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B;;wCAEwC;AACxC;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;;wCAEwC;AACxC;EACE,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,SAAS;EACT,OAAO;EACP,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;;wCAEwC;AACxC;EACE,SAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,4BAA4B;EAC5B,8CAA8C;EAC9C,gBAAgB;EAChB,yDAA0L;EAC1L,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;;wCAEwC;AACxC;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,qDAAqD;EACrD,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,kBAAkB;AAClB,2BAA2B,sBAAsB,EAAE;AACnD,2BAA2B,sBAAsB,EAAE;AACnD,2BAA2B,sBAAsB,EAAE;AACnD,2BAA2B,sBAAsB,EAAE;AACnD,2BAA2B,sBAAsB,EAAE;;AAEnD,gCAAgC;AAChC;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;EACtC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;;EAEE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,uBAAuB;EACvB,+CAA+C;EAC/C,oCAAoC;EACpC,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,sCAAsC;EACtC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;EAC1B,+BAA+B;EAC/B,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;EAC9B,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;;wCAEwC;AACxC;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,sCAAsC;EACtC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;;EAEE,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;;wCAEwC;AACxC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;;wCAEwC;AACxC;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;wCAEwC;AACxC;EACE,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;wCAEwC;AACxC;EACE;IACE,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,2CAA2C;EAC7C;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,QAAQ;IACR,qBAAqB;EACvB;;EAEA,kCAAkC,aAAa,EAAE;;EAEjD;IACE,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,kCAAkC;IAClC,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA,oBAAoB,iBAAiB,EAAE;;EAEvC;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA,cAAc,SAAS,EAAE;;EAEzB,YAAY,uBAAuB,EAAE;;EAErC;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA,mBAAmB,WAAW,EAAE;;EAEhC,kBAAkB,kBAAkB,EAAE;AACxC;;AAEA;EACE,kBAAkB,iBAAiB,EAAE;EACrC,cAAc,+BAA+B,EAAE;EAC/C,wBAAwB,eAAe,EAAE;EACzC,eAAe,uBAAuB,EAAE;AAC1C","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap');\n\n/* ── Variables ── */\n:root {\n  --bg: #f0f2f5;\n  --surface: #ffffff;\n  --surface-2: #f8f9fb;\n  --border: #e0e3e8;\n  --border-hover: #c4c8d2;\n  --accent: #1a73e8;\n  --accent-dark: #1558b0;\n  --accent-soft: #e8f0fe;\n  --accent-glow: rgba(26,115,232,0.18);\n  --nav-blue: #1a73e8;\n  --nav-blue-dark: #1252a3;\n  --nav-blue-active: #0f3d7a;\n  --text-primary: #1c1e21;\n  --text-secondary: #5f6368;\n  --text-muted: #9aa0a6;\n  --shadow-sm: 0 1px 4px rgba(0,0,0,0.07);\n  --shadow-md: 0 4px 16px rgba(0,0,0,0.1);\n  --shadow-lg: 0 8px 32px rgba(0,0,0,0.12);\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 16px;\n  --status-processing-bg: #fff8e1;\n  --status-processing-color: #f59e0b;\n  --status-shipped-bg: #e0f2fe;\n  --status-shipped-color: #0284c7;\n  --status-delivered-bg: #dcfce7;\n  --status-delivered-color: #16a34a;\n  --status-cancelled-bg: #fee2e2;\n  --status-cancelled-color: #dc2626;\n}\n\n* { box-sizing: border-box; }\n\n/* ══════════════════════════════════════\n   MAIN LAYOUT\n══════════════════════════════════════ */\n.my-orders-container {\n  display: flex;\n  min-height: calc(100vh - 60px);\n  margin-top: 70px;\n  padding-top: 30px;\n  background-color: var(--bg);\n  font-family: 'DM Sans', sans-serif;\n}\n\n@media (min-width: 1024px) {\n  .my-orders-container {\n    margin-top: 70px;\n    padding-top: 34px;\n  }\n}\n\n/* ══════════════════════════════════════\n   SIDEBAR NAV\n══════════════════════════════════════ */\n.main-nav {\n  width: 280px;\n  background: linear-gradient(160deg, #1a73e8 0%, #1252a3 100%);\n  color: white;\n  padding: 28px 0;\n  height: calc(100vh - 70px);\n  position: fixed;\n  top: 70px;\n  left: 0;\n  box-shadow: 4px 0 20px rgba(26,115,232,0.25);\n  display: flex;\n  flex-direction: column;\n  z-index: 100;\n}\n\n.main-nav .nav-header {\n  padding: 0 24px 24px;\n  margin-bottom: 8px;\n  font-size: 1.3rem;\n  font-weight: 700;\n  color: white;\n  letter-spacing: -0.3px;\n  border-bottom: 1px solid rgba(255,255,255,0.15);\n}\n\n.main-nav .nav-header::before {\n  content: '📦 ';\n  font-size: 1.1rem;\n}\n\n.main-nav ul {\n  list-style: none;\n  padding: 12px 0;\n  margin: 0;\n  flex: 1;\n}\n\n.main-nav li {\n  margin: 4px 12px;\n  padding: 13px 16px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 500;\n  border-radius: var(--radius-sm);\n  transition: all 0.2s ease;\n  color: rgba(255,255,255,0.85);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.main-nav li:hover {\n  background: rgba(255,255,255,0.12);\n  color: white;\n  padding-left: 20px;\n}\n\n.main-nav li.active {\n  background: rgba(255,255,255,0.2);\n  color: white;\n  font-weight: 700;\n  border-left: 3px solid white;\n  padding-left: 13px;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.15);\n}\n\n.orders-count-badge {\n  background: rgba(255,255,255,0.25);\n  color: white;\n  border-radius: 100px;\n  padding: 2px 10px;\n  font-size: 12px;\n  font-weight: 700;\n  min-width: 24px;\n  text-align: center;\n  border: 1px solid rgba(255,255,255,0.3);\n}\n\n/* ══════════════════════════════════════\n   CONTENT AREA\n══════════════════════════════════════ */\n.orders-content {\n  flex: 1;\n  margin-left: 280px;\n  padding: 32px 36px;\n  background-color: var(--bg);\n  min-height: calc(100vh - 70px);\n}\n\n/* ── Orders Header ── */\n.orders-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  padding-bottom: 18px;\n  border-bottom: 2px solid var(--border);\n}\n\n.orders-header h1 {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n  letter-spacing: -0.4px;\n}\n\n/* ── Filter ── */\n.orders-filter {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 24px;\n}\n\n.orders-filter span {\n  font-weight: 600;\n  color: var(--text-secondary);\n  font-size: 14px;\n}\n\n.orders-filter select,\n.status-dropdown {\n  padding: 9px 14px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n  background-color: var(--surface);\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px;\n  color: var(--text-primary);\n  cursor: pointer;\n  box-shadow: var(--shadow-sm);\n  transition: border-color 0.2s, box-shadow 0.2s;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%235f6368' d='M6 8L1 3h10z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  padding-right: 30px;\n}\n\n.orders-filter select:focus,\n.status-dropdown:focus {\n  outline: none;\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-soft);\n}\n\n/* ══════════════════════════════════════\n   ORDER CARD\n══════════════════════════════════════ */\n.order-card {\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  margin-bottom: 20px;\n  background: var(--surface);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n  animation: fadeUp 0.3s ease both;\n}\n\n.order-card:hover {\n  box-shadow: var(--shadow-md);\n  transform: translateY(-2px);\n}\n\n@keyframes fadeUp {\n  from { opacity: 0; transform: translateY(10px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* Stagger cards */\n.order-card:nth-child(1) { animation-delay: 0.04s; }\n.order-card:nth-child(2) { animation-delay: 0.08s; }\n.order-card:nth-child(3) { animation-delay: 0.12s; }\n.order-card:nth-child(4) { animation-delay: 0.16s; }\n.order-card:nth-child(5) { animation-delay: 0.20s; }\n\n/* ── Order Card Header Bar ── */\n.order-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 16px 20px;\n  background: var(--surface-2);\n  border-bottom: 1px solid var(--border);\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.order-meta {\n  display: flex;\n  gap: 28px;\n  flex-wrap: wrap;\n}\n\n.order-date,\n.order-total {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.order-date span:first-child,\n.order-total span:first-child {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: var(--text-muted);\n}\n\n.order-date span:last-child,\n.order-total span:last-child {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.order-id {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 3px;\n}\n\n.order-id span {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-muted);\n}\n\n.order-id a {\n  color: var(--accent);\n  text-decoration: none;\n  font-size: 13px;\n  font-weight: 500;\n  transition: color 0.15s;\n}\n\n.order-id a:hover {\n  color: var(--accent-dark);\n  text-decoration: underline;\n}\n\n/* ── Status Bar ── */\n.order-status-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 20px;\n  border-bottom: 1px solid var(--border);\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.order-status {\n  font-weight: 600;\n  font-size: 13px;\n  padding: 6px 14px;\n  border-radius: 100px;\n  letter-spacing: 0.2px;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.order-status::before {\n  content: '';\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n  opacity: 0.7;\n}\n\n.status-processing {\n  background: var(--status-processing-bg);\n  color: var(--status-processing-color);\n}\n\n.status-out,\n.status-shipped {\n  background: var(--status-shipped-bg);\n  color: var(--status-shipped-color);\n}\n\n.status-delivered {\n  background: var(--status-delivered-bg);\n  color: var(--status-delivered-color);\n}\n\n.status-cancelled {\n  background: var(--status-cancelled-bg);\n  color: var(--status-cancelled-color);\n}\n\n/* ── Cancel Button ── */\n.cancel-order-btn {\n  background: transparent;\n  border: 1px solid var(--status-cancelled-color);\n  color: var(--status-cancelled-color);\n  padding: 6px 14px;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  transition: all 0.18s ease;\n}\n\n.cancel-order-btn:hover {\n  background: var(--status-cancelled-color);\n  color: white;\n}\n\n/* ── Order Items ── */\n.order-items {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 0 20px;\n}\n\n.order-item {\n  display: flex;\n  gap: 16px;\n  padding: 18px 0;\n  border-bottom: 1px solid var(--border);\n  transition: background 0.15s;\n  position: relative;\n}\n\n.order-item:last-child {\n  border-bottom: none;\n}\n\n.order-item:hover {\n  background: var(--surface-2);\n  margin: 0 -20px;\n  padding-left: 20px;\n  padding-right: 20px;\n  border-radius: 0;\n}\n\n.order-item-image {\n  width: 78px;\n  height: 78px;\n  object-fit: contain;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  background: white;\n  padding: 6px;\n  flex-shrink: 0;\n}\n\n.order-item-details {\n  flex: 1;\n  min-width: 0;\n}\n\n.order-item-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 5px;\n  line-height: 1.4;\n}\n\n.order-item-price {\n  font-weight: 700;\n  color: var(--text-primary);\n  font-size: 15px;\n  margin-bottom: 4px;\n}\n\n.order-item-quantity,\n.order-item-page {\n  color: var(--text-secondary);\n  font-size: 13px;\n  margin-bottom: 2px;\n}\n\n/* ── Item Actions ── */\n.order-item-actions {\n  display: flex;\n  gap: 16px;\n  margin-top: 10px;\n}\n\n.action-btn {\n  background: none;\n  border: none;\n  color: var(--accent);\n  cursor: pointer;\n  font-size: 13px;\n  font-family: 'DM Sans', sans-serif;\n  font-weight: 500;\n  padding: 0;\n  transition: color 0.15s;\n}\n\n.action-btn:hover {\n  color: var(--accent-dark);\n  text-decoration: underline;\n}\n\n/* ── Order Footer ── */\n.order-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 14px 20px;\n  border-top: 1px solid var(--border);\n  background: var(--surface-2);\n}\n\n.track-package-btn,\n.leave-feedback-btn {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  padding: 8px 16px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-family: 'DM Sans', sans-serif;\n  font-weight: 500;\n  color: var(--text-primary);\n  transition: all 0.18s ease;\n  box-shadow: var(--shadow-sm);\n}\n\n.track-package-btn:hover,\n.leave-feedback-btn:hover {\n  background: var(--accent-soft);\n  border-color: var(--accent);\n  color: var(--accent);\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px var(--accent-glow);\n}\n\n/* ══════════════════════════════════════\n   CUSTOMER INFO (Merchant View)\n══════════════════════════════════════ */\n.customer-info {\n  margin: 16px 20px;\n  padding: 16px;\n  background: var(--accent-soft);\n  border: 1px solid rgba(26,115,232,0.2);\n  border-radius: var(--radius-md);\n  border-left: 4px solid var(--accent);\n}\n\n.customer-info span,\n.customer-detail {\n  font-size: 13.5px;\n  color: var(--text-secondary);\n  display: flex;\n  gap: 6px;\n  margin-bottom: 4px;\n}\n\n.customer-detail strong {\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n/* ── Customer Orders List (legacy) ── */\n.customer-orders-list {\n  margin-top: 100px;\n  font-family: 'DM Sans', sans-serif;\n}\n\n.customer-orders-list h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 20px;\n  padding-bottom: 14px;\n  border-bottom: 2px solid var(--border);\n}\n\n/* ══════════════════════════════════════\n   LOADING SPINNER\n══════════════════════════════════════ */\n.flipkart-spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 220px;\n  width: 100%;\n}\n\n.spinner-container {\n  text-align: center;\n}\n\n.spinner {\n  border: 3px solid var(--accent-soft);\n  border-radius: 50%;\n  border-top-color: var(--accent);\n  width: 40px;\n  height: 40px;\n  animation: spin 0.75s linear infinite;\n  margin: 0 auto 14px;\n  box-shadow: 0 0 12px var(--accent-glow);\n}\n\n.loading-text {\n  color: var(--accent);\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 0.2px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ══════════════════════════════════════\n   EMPTY STATE\n══════════════════════════════════════ */\n.empty-orders {\n  text-align: center;\n  padding: 60px 40px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  margin-top: 10px;\n}\n\n.empty-orders-icon {\n  font-size: 52px;\n  margin-bottom: 18px;\n  color: var(--text-muted);\n  opacity: 0.6;\n}\n\n.empty-orders h3 {\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.empty-orders p {\n  color: var(--text-secondary);\n  margin-bottom: 24px;\n  font-size: 14px;\n  max-width: 320px;\n  margin-left: auto;\n  margin-right: auto;\n  line-height: 1.6;\n}\n\n.continue-shopping-btn {\n  background: var(--accent);\n  color: white;\n  border: none;\n  padding: 11px 28px;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: 'DM Sans', sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  box-shadow: 0 3px 12px var(--accent-glow);\n}\n\n.continue-shopping-btn:hover {\n  background: var(--accent-dark);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px var(--accent-glow);\n}\n\n/* ══════════════════════════════════════\n   POPUP MODAL\n══════════════════════════════════════ */\n.popup-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.4);\n  backdrop-filter: blur(4px);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: fadeIn 0.15s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n.popup-modal {\n  background: var(--surface);\n  padding: 36px 32px 28px;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  max-width: 420px;\n  width: 90%;\n  text-align: center;\n  animation: slideUp 0.2s ease;\n  border: 1px solid var(--border);\n}\n\n@keyframes slideUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.popup-modal p {\n  margin-bottom: 24px;\n  font-size: 16px;\n  color: var(--text-primary);\n  font-weight: 500;\n  line-height: 1.5;\n}\n\n.popup-modal .modal-buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.confirm-remove-btn {\n  background: #dc2626;\n  color: white;\n  border: none;\n  padding: 10px 24px;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: 'DM Sans', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.18s ease;\n  flex: 1;\n  max-width: 160px;\n}\n\n.confirm-remove-btn:hover {\n  background: #b91c1c;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(220,38,38,0.3);\n}\n\n.cancel-remove-btn {\n  background: var(--surface-2);\n  color: var(--text-secondary);\n  border: 1px solid var(--border);\n  padding: 10px 24px;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: 'DM Sans', sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.18s ease;\n  flex: 1;\n  max-width: 160px;\n}\n\n.cancel-remove-btn:hover {\n  background: var(--border);\n  color: var(--text-primary);\n}\n\n/* ══════════════════════════════════════\n   LEGACY / STANDALONE ORDERS CONTAINER\n══════════════════════════════════════ */\n.orders-container {\n  max-width: 1100px;\n  margin: 120px auto 40px;\n  padding: 0 20px;\n  font-family: 'DM Sans', sans-serif;\n}\n\n/* ══════════════════════════════════════\n   RESPONSIVE\n══════════════════════════════════════ */\n@media (max-width: 900px) {\n  .my-orders-container {\n    flex-direction: column;\n    margin-top: 70px;\n    padding-top: 0;\n  }\n\n  .main-nav {\n    width: 100%;\n    height: auto;\n    position: static;\n    padding: 12px 0;\n    box-shadow: 0 4px 12px rgba(26,115,232,0.2);\n  }\n\n  .main-nav .nav-header {\n    padding: 0 16px 12px;\n    margin-bottom: 4px;\n    font-size: 1.1rem;\n  }\n\n  .main-nav ul {\n    display: flex;\n    overflow-x: auto;\n    padding: 4px 8px;\n    gap: 4px;\n    scrollbar-width: none;\n  }\n\n  .main-nav ul::-webkit-scrollbar { display: none; }\n\n  .main-nav li {\n    margin: 0;\n    padding: 10px 16px;\n    white-space: nowrap;\n    border-radius: 100px;\n    border-left: none !important;\n    flex-shrink: 0;\n  }\n\n  .main-nav li.active {\n    background: rgba(255,255,255,0.25);\n    border-bottom: none;\n    padding-left: 16px;\n  }\n\n  .orders-content {\n    margin-left: 0;\n    padding: 20px 16px;\n  }\n\n  .orders-container {\n    margin-top: 60px;\n  }\n}\n\n@media (max-width: 600px) {\n  .orders-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .orders-header h1 { font-size: 1.4rem; }\n\n  .order-header {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .order-meta { gap: 14px; }\n\n  .order-id { align-items: flex-start; }\n\n  .order-item {\n    flex-direction: column;\n  }\n\n  .order-item-image {\n    width: 100%;\n    height: 140px;\n    border-radius: var(--radius-md);\n  }\n\n  .order-footer {\n    flex-direction: column;\n  }\n\n  .track-package-btn,\n  .leave-feedback-btn {\n    justify-content: center;\n  }\n\n  .status-dropdown { width: 100%; }\n\n  .orders-content { padding: 14px 12px; }\n}\n\n@media (max-width: 400px) {\n  .orders-content { padding: 10px 8px; }\n  .order-card { border-radius: var(--radius-sm); }\n  .main-nav .nav-header { font-size: 1rem; }\n  .popup-modal { padding: 24px 18px 20px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
